import React, { useState } from 'react';

const VasZahtev = ({ vasZahtevRef }) => {
  const [ime, setIme] = useState('');
  const [email, setEmail] = useState('');
  const [poruka, setPoruka] = useState('');
  const [uspesnoPoslat, setUspesnoPoslat] = useState(false); // Novo stanje

  const handleSubmit = (e) => {
    e.preventDefault();

    const zahtevData = { ime, email, poruka };
    console.log('Slanje podataka:', zahtevData);

    fetch('https://nekretnine-7fa1e091ccac.herokuapp.com/api/vas-zahtev', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(zahtevData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
        setIme('');
        setEmail('');
        setPoruka('');
        setUspesnoPoslat(true); // Postavi da je uspešno poslato
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  return (
    <div ref={vasZahtevRef} className="relative flex flex-col min-h-[60vh] bg-gray-900 pb-2">
      <div className="w-full z-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 200" className="w-full" preserveAspectRatio="none">
          <path fill="#1F2937" d="M0,320L80,300C160,280,320,260,480,260C640,260,800,280,960,290C1120,300,1280,310,1360,320L1440,320L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
          <path fill="#111827" d="M0,160L80,140C160,120,320,100,480,100C640,100,800,120,960,130C1120,140,1280,150,1360,160L1440,170L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      </div>

      <div className="flex justify-center items-start mt-16 w-full px-4 sm:px-8 relative z-10">
        <div className="p-4 sm:p-6 bg-gray-800 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md h-auto min-h-[20vh] border-2 border-pink-600 transition-shadow duration-300" style={{ boxShadow: '0 0 15px 3px rgba(225, 0, 85, 0.7)' }}>
          <h2 className="text-lg sm:text-xl font-bold mb-4 text-white text-center">Vaš Zahtev</h2>
          <form onSubmit={handleSubmit} className="flex flex-col space-y-3 w-full">
            <div className="mb-2">
              <label htmlFor="ime" className="block text-gray-300 font-semibold mb-1 text-xs sm:text-sm">
                Ime:
              </label>
              <input
                type="text"
                id="ime"
                value={ime}
                onChange={(e) => setIme(e.target.value)}
                className="w-full p-1 sm:p-2 border-2 border-pink-600 rounded bg-gray-700 text-white focus:shadow-[0_0_5px_rgba(219,39,119,0.8)] focus:outline-none transition-shadow duration-300 text-xs sm:text-sm"
                placeholder="Vaše ime"
                required
              />
            </div>
            <div className="mb-2">
              <label htmlFor="email" className="block text-gray-300 font-semibold mb-1 text-xs sm:text-sm">
                Email:
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-1 sm:p-2 border-2 border-pink-600 rounded bg-gray-700 text-white focus:shadow-[0_0_5px_rgba(219,39,119,0.8)] focus:outline-none transition-shadow duration-300 text-xs sm:text-sm"
                placeholder="Vaš email"
                required
              />
            </div>
            <div className="mb-2">
              <label htmlFor="poruka" className="block text-gray-300 font-semibold mb-1 text-xs sm:text-sm">
                Poruka:
              </label>
              <textarea
                id="poruka"
                value={poruka}
                onChange={(e) => setPoruka(e.target.value)}
                className="w-full p-1 sm:p-2 border-2 border-pink-600 rounded bg-gray-700 text-white focus:shadow-[0_0_5px_rgba(219,39,119,0.8)] focus:outline-none transition-shadow duration-300 text-xs sm:text-sm"
                placeholder="Vaša poruka"
                rows="3"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-pink-600 text-white px-3 py-1 sm:py-2 w-auto rounded-lg transition duration-300 mx-auto hover:bg-pink-700 hover:text-black hover:shadow-[0_0_10px_2px_rgba(225,0,85,1)] text-xs sm:text-sm"
            >
              Pošalji
            </button>
          </form>

          {uspesnoPoslat && (
            <div className="bg-green-600 text-white p-2 rounded-lg mt-4 text-center">
              Uspešno ste poslali zahtev!
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VasZahtev;
